import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { IconViewSuperEllipse as Icon } from '@alfa-bank/site-icon-view/super-ellipse';
import { Skeleton } from '@alfa-bank/site-skeleton';

import { ProfitabilityCellDesktop as ProfitabilityCell } from '../../cells/profitability/desktop';
import type { IQuotationCardProps } from '../models';

import styles from './styles.css';

export const QuotationCardDesktop: FC<IQuotationCardProps> = ({
    imageSrc,
    isLoading,
    name,
    pricePercentChange,
    trend,
}) => {
    return isLoading ? (
        <Skeleton
            borderRadius={24}
            className={cn(styles.external, styles.skeleton)}
            colors="inverted"
            dataTestId="market-quotations-skeleton"
        />
    ) : (
        <Block
            className={cn(styles.external, styles.block)}
            notPadded
            overflowHidden
            styler={{
                paddingRight: 24,
                paddingTop: 24,
                paddingBottom: 24,
                paddingLeft: 24,
                borderRadius: 24,
            }}
            theme="white"
        >
            <Grid alignment="center" collapse columnsWidth={[40, 16, null]}>
                <Icon backgroundColor="transparent" imageUrl={imageSrc} mainSize={24} size={40} />
                <></>
                <Grid collapse flexDirection="column">
                    <ProfitabilityCell pricePercentChange={pricePercentChange} trend={trend} />
                    <Text
                        className={cn(styles.external, styles.assetName)}
                        styler={{ margin: 0 }}
                        view="primary-medium"
                    >
                        {name}
                    </Text>
                </Grid>
            </Grid>
        </Block>
    );
};
